import { compose, lifecycle, setDisplayName, withState } from 'recompose'
import { delay, once } from 'lodash'
import { clearTimeout } from 'src/helpers/browser'

/**
 * withDelayedRenderValue
 * Utility for delayed a prop send to a child component. Using
 * this to delay countUp animations for framerate reasons
 */
const withDelayedRenderValue = ({
  fromProp,
  toProp,
  initialValue,
  timeout = 750
}) =>
  compose(
    setDisplayName('withDelayedRenderValue'),
    withState(toProp, 'setDelayedRenderValue', initialValue),
    lifecycle({
      componentDidMount () {
        this.update = once(this.update.bind(this))

        this.timer = delay(this.update, timeout)
      },

      componentWillUnmount () {
        clearTimeout(this.timer)
      },

      update () {
        const { [fromProp]: propValue, setDelayedRenderValue } = this.props
        setDelayedRenderValue(propValue)
      }
    })
  )

export default withDelayedRenderValue
